module.exports = __webpack_public_path__ + "img/preview.7f674444.png";